import { render, staticRenderFns } from "./AlertDetails.html?vue&type=template&id=2223d75c&scoped=true&external"
import script from "./AlertDetails.vue?vue&type=script&lang=js"
export * from "./AlertDetails.vue?vue&type=script&lang=js"
import style0 from "./AlertDetails.scss?vue&type=style&index=0&id=2223d75c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2223d75c",
  null
  
)

export default component.exports